import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import ContactController from '../../controller/ContactController';
import ContactAddEditInfo from './ContactAddEditInfo';
import ContactAddEditContact from './ContactAddEditContact';
import ContactAddEditCustom from './ContactAddEditCustom';

import ContactAPI from '../../api/ContactAPI';
import ApiUiController from '../../controller/ApiUiController';
import ValidationController from '../../controller/ValidationController';
import Util from '../../util/Util';

class ContactUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.contactId);
    this.model = reactLocalStorage.getObject(Const.Model).contact;
    this.contact = ContactController.addModel(this.model.fields);
    
    //let baseValue = '/add-edit/:contactId';
    if(props.match.params.moduleNo && parseInt(props.match.params.moduleNo) === Const.Lead) {
      this.contact.model_no = Const.Lead;
      this.contact.model_id = parseInt(props.match.params.modelId);
      //baseValue = '/add-edit/:contactId/:leadId'
    }
    if(props.match.params.moduleNo && parseInt(props.match.params.moduleNo) === Const.Property) {
      this.contact.model_no = Const.Property;
      this.contact.model_id = parseInt(props.match.params.modelId);
      //baseValue = '/add-edit/:contactId/:propertyId'
    }
    if(props.match.params.moduleNo && parseInt(props.match.params.moduleNo) === Const.Project) {
      this.contact.model_no = Const.Project;
      this.contact.model_id = parseInt(props.match.params.modelId);
      //baseValue = '/add-edit/:contactId/:projectId'
    }
    this.contact.id = 0;
    this.state = { inApiCall: this.id !== 0, inValid: { } };

    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if(this.id !== 0) {
      ContactAPI.get(this.id, this.onReceived, this.failure);
    }
  }

  failure = res => {
    this.setState({ ...this.state, inApiCall: false, inValid: { ...res } });
    // const message = Util.failure(inValid);
      Util.showError(res);
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.contact);
    if(inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      ContactAPI.save(this.contact, this.onUpdateReceived, this.failure);
      Util.showNotification('Successful', 'Contact saved successfully', 'success');
    } else {
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  }
  onReceived = contact => {
    this.contact = contact;
    this.setState({ ...this.state, inApiCall: false }); 
  }
  onUpdateReceived = res => this.props.navigate(`${this.base}/preview/${res.id}`);

  onValueChange = (field, value) => {
    this.contact[field] = value;
    this.setState({ ...this.state, inValid: {} });
  }
  
  render() {
    return (
      <div className="sectionform">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              
              <ContactAddEditInfo model={this.model} contact={this.contact} module={this.model}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <ContactAddEditContact model={this.model} contact={this.contact}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />
              
              <ContactAddEditCustom model={this.model} contact={this.contact}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />
              
              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>
                  { this.id === 0 ? 'Save' : 'Update' } Contact
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(ContactUpdate);